/*! @pentacode/ui v0.1.0 */
import { t as e } from "../../../styledElement-Dm1irIE2.js";
import { t } from "../../../decorateMetadata-BhwOl-pv.js";
import { t as n } from "../../../decorate-DHgd5sZx.js";
import { FormElement as r } from "../../formElement.js";
import "../../../checkbox-BOki-Nk5.js";
import "../../form-elements/select.js";
import { LitElement as i, html as a, nothing as o } from "lit";
import { customElement as s, property as c, state as l } from "lit/decorators.js";
//#region src/elements/employee-questionnaire/shared/disability-section.ts
var u = [
	{
		label: "20%",
		value: "20"
	},
	{
		label: "30%",
		value: "30"
	},
	{
		label: "40%",
		value: "40"
	},
	{
		label: "50%",
		value: "50"
	},
	{
		label: "60%",
		value: "60"
	},
	{
		label: "70%",
		value: "70"
	},
	{
		label: "80%",
		value: "80"
	},
	{
		label: "90%",
		value: "90"
	},
	{
		label: "100%",
		value: "100"
	}
], d = class extends e(r(i)) {
	constructor(...e) {
		super(...e), this.data = { disabilityLevel: !1 }, this._disabilityLevel = !1, this._disabilityLevelPercentage = "";
	}
	willUpdate(e) {
		e.has("data") && this.data && (this._disabilityLevel = this.data.disabilityLevel, this._disabilityLevelPercentage = this.data.disabilityLevelPercentage?.toString() ?? "");
	}
	_handleSectionChange() {
		this._disabilityLevel || (this._disabilityLevelPercentage = ""), this.dispatchEvent(new CustomEvent("change", {
			detail: {
				disabilityLevel: this._disabilityLevel,
				disabilityLevelPercentage: this._disabilityLevelPercentage ? parseInt(this._disabilityLevelPercentage, 10) : void 0
			},
			bubbles: !0,
			composed: !0
		}));
	}
	render() {
		return a`
            <section class="w-full">
                <h2 class="mb-4 px-2 text-xl font-semibold">Schwerbehinderung</h2>

                <div class="flex flex-col gap-4">
                    <div class="flex items-center gap-2 px-2">
                        <ptc-ui-checkbox
                            id="disabilityLevel"
                            name="disabilityLevel"
                            .checked=${this._disabilityLevel}
                            @change=${(e) => {
			e.stopPropagation(), this._disabilityLevel = e.detail.checked, this._handleSectionChange();
		}}
                        ></ptc-ui-checkbox>
                        <label for="disabilityLevel" class="text-sm font-medium text-gray-700">
                            Grad der Behinderung angeben
                            <span class="block text-xs text-gray-500">Freiwillige Angabe</span>
                        </label>
                    </div>

                    ${this._disabilityLevel ? a`
                              <div class="flex gap-4">
                                  <div class="flex-1">
                                      <ptc-ui-select
                                          .options=${u}
                                          name="disabilityLevelPercentage"
                                          label="Grad der Behinderung"
                                          placeholder="Grad auswählen"
                                          .value=${this._disabilityLevelPercentage}
                                          required
                                          @change=${(e) => {
			e.stopPropagation(), this._disabilityLevelPercentage = e.detail.value, this._handleSectionChange();
		}}
                                      ></ptc-ui-select>
                                      <p class="mt-1 px-2 text-xs text-gray-500">Schwerbehinderung in % (20-100)</p>
                                  </div>
                                  <div class="flex-1"></div>
                              </div>
                          ` : o}
                </div>
            </section>
        `;
	}
};
n([c({ type: Object }), t("design:type", Object)], d.prototype, "data", void 0), n([l(), t("design:type", Object)], d.prototype, "_disabilityLevel", void 0), n([l(), t("design:type", Object)], d.prototype, "_disabilityLevelPercentage", void 0), d = n([s("ptc-ui-employee-questionnaire-disability-section")], d);
//#endregion
export { d as EmployeeQuestionnaireDisabilitySection };

//# sourceMappingURL=disability-section.js.map